import { supabase, applyOrgFilter, getActiveOrgOverride } from '../supabaseClient'
import { getCurrentStaff } from './auth'
import { TEMPORADA_ESTADOS } from '../../constants/temporadas'

export async function getTemporadas(soloActivas = true) {
  try {
    let query = supabase
      .from('temporadas')
      .select('*, deporte:deportes(id, nombre)')
      .is('deleted_at', null)
      .order('fecha_inicio', { ascending: false });

    if (soloActivas) {
      query = query.eq('activa', true);
    }

    query = applyOrgFilter(query);

    const { data, error } = await query;

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error obteniendo temporadas:', error);
    return { data: null, error };
  }
}

export async function getTemporadaById(temporadaId) {
  try {
    const { data, error } = await supabase
      .from('temporadas')
      .select('*, deporte:deportes(id, nombre)')
      .eq('id', temporadaId)
      .is('deleted_at', null)
      .single();

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error obteniendo temporada por ID:', error);
    return { data: null, error };
  }
}

export async function createTemporada(temporadaData) {
  try {
    if (!temporadaData.deporte_id) {
      throw new Error('El deporte es requerido para la temporada')
    }
    const estado = temporadaData.estado || 'planeada'
    if (!TEMPORADA_ESTADOS.includes(estado)) {
      throw new Error('Estado de temporada inválido')
    }
    // Sin org no se adivina: caer a la org por defecto guardaba la temporada en otra org.
    const orgId = getActiveOrgOverride() || temporadaData.org_id || (await getCurrentStaff())?.data?.org_id
    if (!orgId) {
      throw new Error('No se pudo saber tu organización. Recarga la página e intenta de nuevo.')
    }
    const { data, error } = await supabase
      .from('temporadas')
      .insert([{
        nombre: temporadaData.nombre,
        fecha_inicio: temporadaData.fecha_inicio,
        fecha_fin: temporadaData.fecha_fin,
        descripcion: temporadaData.descripcion,
        deporte_id: temporadaData.deporte_id,
        estado,
        activa: estado === 'abierta',
        org_id: orgId,
      }])
      .select()
      .single();

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error creando temporada:', error);
    return { data: null, error };
  }
}

export async function updateTemporada(temporadaId, updates) {
  try {
    const payload = { ...updates, updated_at: new Date().toISOString() };
    // Mantener activa en sync con estado para consumidores legacy (entrenamientos)
    if (updates.estado !== undefined && updates.activa === undefined) {
      payload.activa = updates.estado === 'abierta';
    }
    const { data, error } = await supabase
      .from('temporadas')
      .update(payload)
      .eq('id', temporadaId)
      .select()
      .single();

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error actualizando temporada:', error);
    return { data: null, error };
  }
}

export async function deleteTemporada(temporadaId) {
  try {
    const { data, error } = await supabase
      .from('temporadas')
      .update({
        deleted_at: new Date().toISOString(),
        updated_at: new Date().toISOString(),
      })
      .eq('id', temporadaId)
      .select()
      .single();

    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error eliminando temporada:', error);
    return { data: null, error };
  }
}

// Mantiene activa en sync con estado para consumidores legacy (entrenamientos)
async function setEstado(temporadaId, estado) {
  try {
    if (!temporadaId) throw new Error('temporadaId es requerido');
    const { data, error } = await supabase
      .from('temporadas')
      .update({
        estado,
        activa: estado === 'abierta',
        updated_at: new Date().toISOString(),
      })
      .eq('id', temporadaId)
      .select()
      .single();
    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error cambiando estado de temporada:', error);
    return { data: null, error };
  }
}

export const abrirTemporada = (temporadaId) => setEstado(temporadaId, 'abierta')
export const cerrarTemporada = (temporadaId) => setEstado(temporadaId, 'cerrada')

export async function getTemporadasAbiertas({ deporteId = null } = {}) {
  try {
    let query = supabase
      .from('temporadas')
      .select('*, deporte:deportes(id, nombre)')
      .is('deleted_at', null)
      .eq('estado', 'abierta');

    if (deporteId) query = query.eq('deporte_id', deporteId);
    query = applyOrgFilter(query);
    // Orden por fecha de inicio, más reciente primero
    query = query.order('fecha_inicio', { ascending: false });

    const { data, error } = await query;
    if (error) throw error;
    return { data, error: null };
  } catch (error) {
    console.error('Error obteniendo temporadas abiertas:', error);
    return { data: null, error };
  }
}
